/* NEGT Leather: motion layer (deferred, no dependencies).
   Loaded only when Theme settings > Animations > "Enable animations" is on.
   Does nothing for visitors who prefer reduced motion. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) { root.classList.remove('negt-anim'); return; }
  root.classList.add('negt-anim');
  window.NEGT_MOTION = true;

  var REVEAL = '[data-reveal], .section-head, .page-head, .footer__brand, .footer__col';
  var STAGGER_STEP = 70;

  /* ---------- Scroll reveal + stagger (IntersectionObserver, once) ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

  function prepStagger(scope) {
    (scope || document).querySelectorAll('[data-stagger]').forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, i) {
        child.style.setProperty('--rd', Math.min(i, 8) * STAGGER_STEP + 'ms');
      });
    });
    (scope || document).querySelectorAll('.footer__grid').forEach(function (grid) {
      Array.prototype.forEach.call(grid.children, function (child, i) { child.style.setProperty('--rd', i * 90 + 'ms'); });
    });
  }

  function observe(scope) {
    var s = scope || document;
    var nodes = s.querySelectorAll(REVEAL + ', [data-stagger] > *');
    nodes.forEach(function (n) {
      if (n.closest('.product__info')) { n.classList.add('is-in'); return; } // never delay buying controls
      if (!io) { n.classList.add('is-in'); return; }
      io.observe(n);
    });
  }

  /* ---------- Sticky header: shrink + cream blur after 80px ---------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var on = false, ticking = false;
    function update() {
      var should = window.scrollY > 80;
      if (should !== on) { on = should; header.classList.toggle('is-scrolled', on); }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- Page transitions ---------- */
  function initTransitions() {
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest('a');
      if (!a || a.target === '_blank' || a.hasAttribute('download') || a.dataset.noTransition !== undefined) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
      var url;
      try { url = new URL(a.href, location.href); } catch (err) { return; }
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
      if (/\/(cart|checkout|account)/.test(url.pathname) && a.closest('.cart-drawer')) return;
      e.preventDefault();
      root.classList.add('is-leaving');
      setTimeout(function () { location.href = url.href; }, 170);
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) root.classList.remove('is-leaving'); });
  }

  /* ---------- Parallax (transform only) ---------- */
  function initParallax() {
    var items = document.querySelectorAll('[data-parallax]');
    if (!items.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var box = el.parentElement.getBoundingClientRect();
        if (box.bottom < 0 || box.top > vh) return;
        var progress = (box.top + box.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (progress * -60).toFixed(1) + 'px,0) scale(1.15)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- Accordions: smooth height ---------- */
  function initAccordions(scope) {
    (scope || document).querySelectorAll('details.accordion, details.faq__item').forEach(function (d) {
      if (d.dataset.motion) return;
      d.dataset.motion = '1';
      var summary = d.querySelector('summary');
      var content = d.querySelector('.accordion__content, .faq__answer');
      if (!summary || !content || !content.animate) return;
      var anim = null;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (anim) anim.cancel();
        if (d.open) {
          var h = content.offsetHeight;
          anim = content.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 280, easing: 'cubic-bezier(.2,.7,.2,1)' });
          anim.onfinish = function () { d.open = false; anim = null; };
        } else {
          d.open = true;
          var target = content.offsetHeight;
          anim = content.animate([{ height: '0px', opacity: 0 }, { height: target + 'px', opacity: 1 }], { duration: 340, easing: 'cubic-bezier(.2,.7,.2,1)' });
          anim.onfinish = function () { anim = null; };
        }
      });
    });
  }

  /* ---------- Product gallery hover zoom (desktop) ---------- */
  function initZoom(scope) {
    if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
    (scope || document).querySelectorAll('.gallery__slide').forEach(function (slide) {
      if (slide.dataset.zoom || !slide.querySelector('img')) return;
      slide.dataset.zoom = '1';
      slide.addEventListener('mouseenter', function () { slide.classList.add('is-zooming'); });
      slide.addEventListener('mouseleave', function () { slide.classList.remove('is-zooming'); });
      slide.addEventListener('mousemove', function (e) {
        var r = slide.getBoundingClientRect();
        slide.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        slide.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      });
    });
  }

  /* ---------- Cart feedback + price fade (events from theme.js) ---------- */
  document.addEventListener('negt:cart:added', function () {
    document.querySelectorAll('.cart-link').forEach(function (l) {
      l.classList.remove('is-bouncing'); void l.offsetWidth; l.classList.add('is-bouncing');
    });
    document.querySelectorAll('[data-cart-count]').forEach(function (c) {
      c.classList.remove('is-ticking'); void c.offsetWidth; c.classList.add('is-ticking');
    });
  });
  document.addEventListener('negt:price:changed', function (e) {
    var el = e.detail && e.detail.el;
    if (!el) return;
    el.classList.remove('price-fade'); void el.offsetWidth; el.classList.add('price-fade');
  });
  document.addEventListener('negt:results:swapped', function (e) {
    var scope = e.detail && e.detail.el;
    if (!scope) return;
    prepStagger(scope);
    scope.querySelectorAll('[data-stagger] > *').forEach(function (n) { n.classList.add('is-in'); });
    scope.classList.remove('is-swapped'); void scope.offsetWidth; scope.classList.add('is-swapped');
  });
  document.addEventListener('negt:content:loaded', function (e) {
    var scope = e.detail && e.detail.el;
    if (!scope) return;
    prepStagger(scope); observe(scope); initAccordions(scope); initZoom(scope);
  });

  function init() {
    prepStagger();
    observe();
    initHeader();
    initTransitions();
    initParallax();
    initAccordions();
    initZoom();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    prepStagger(e.target); observe(e.target); initAccordions(e.target); initZoom(e.target);
    e.target.querySelectorAll(REVEAL + ', [data-stagger] > *').forEach(function (n) { n.classList.add('is-in'); });
  });
})();
